module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/en/4-08641bf52c510bdfb68f1d4bcbe90552.jpg";